<template>
  <div class="recruit content">
    <div class="banner-sub">
      <img :src="topBg.joinDetailTopImg" alt="">
    </div>
    <div class="wrap">
      <div class="job-box">
        <div class="back-btn"><span @click="backHandler()">返回</span></div>
        <div class="head-box">
          <div class="top">
            <div class="txt1">{{ job.position }}</div>
            <span class="txt2">{{ job.salary }}</span>
          </div>
          <span class="left-01">更新于{{ job.publicTime }}</span>
          <div class="left-02">
            <span>{{ job.workTime }}年经验</span>
            <span>{{ job.education }}</span>
            <span>招{{ job.amount }}人</span>
            <span>{{ job.sysDeptName }}</span>
          </div>
        </div>
        <div class="job-item">
          <div class="job-title">
            <h2>公司福利</h2>
          </div>
          <div class="job-content">
            <p v-html="job.welfare"></p>
          </div>
        </div>
        <div class="job-item">
          <div class="job-title">
            <h2>职位描述</h2>
          </div>
          <div class="job-content">
            <p v-html="job.positionDesc"></p>
          </div>
        </div>
        <div class="job-item">
          <div class="job-title">
            <h2>职位要求</h2>
          </div>
          <div class="job-content">
            <p v-html="job.positionRequire"></p>
          </div>
        </div>
        <div class="job-item">
          <div class="job-title">
            <h2>工作地址</h2>
          </div>
          <div class="job-content">
            <p>{{ job.workDetailAddr}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {ApiWebRecruitImg, ApiWebRecruitJoinDetail} from '../api/recruit'
export default {
  name: 'job-detail',
  data () {
    return {
      jobId: null,
      job: null,
      topBg: {
        indexTopIng: null,
        recruitJoinTopImg: null,
        joinDetailTopImg: null
      }
    }
  },
  mounted() {
    this.jobId = this.$route.params.jobId || this.$store.getters['job/getJobId']
    this.topbackground()
    this.$nextTick(() => {
      ApiWebRecruitJoinDetail(this.jobId).then(({ data }) => {
        if (data && data.status === 0) {
          this.job = data.data
          console.log(this.$store.getters['job/getJobId'])
          console.log('this.$store.getters[]')
        }
      })
    })
  },
  methods: {
    /**
     * 人才招聘详细顶部背景图
     */
    topbackground () {
      ApiWebRecruitImg().then(({data}) => {
        if (data && data.status === 0) {
          this.topBg = data.data
        }
      })
    },
    /**
     * 返回招聘岗位列表
     */
    backHandler () {
      this.$router.push({ name: 'recruit'})
    },
  }
}
</script>

<style scoped lang="less">
  @import '../assets/style/index.less';
</style>



// WEBPACK FOOTER //
// src/components/recruit-join-detail.vue